import { DateRange } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import { useEffect } from "react";
import { ObjectStatus } from "../../Core/Api/Types/object-status";
import { IDbBaseMetadataValueInfos } from "../../Core/Api/Types/i-db-base-metadata-value-infos";
import { StatusHistoryFilter } from "../../Redux/Reducers/redux-slice-filters";

const useAdamDateFilterLinkValues = (
  dateValue: DateRange<dayjs.Dayjs>,
  setDateValue: React.Dispatch<React.SetStateAction<DateRange<dayjs.Dayjs>>>,
  linkedDateFilterId: number | null,
  linkedStatusHistoryFilter: ObjectStatus | null,
  filters: IDbBaseMetadataValueInfos[],
  statusHistoryFilter: StatusHistoryFilter[]
) => {
  useEffect(() => {
    const shouldResetDates =
      ((dateValue[0] || dateValue[1]) &&
        !linkedDateFilterId &&
        !statusHistoryFilter.find((x) => x.status === linkedStatusHistoryFilter)) ||
      ((dateValue[0] || dateValue[1]) && linkedDateFilterId && !filters.find((x) => x.id === linkedDateFilterId));

    if (shouldResetDates) setDateValue([null, null]);
  }, [filters.length, statusHistoryFilter.length]);
};

export default useAdamDateFilterLinkValues;
